import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import Snack from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Grow from '@material-ui/core/Grow';

import styles from "assets/jss/material-kit-pro-react/components/snackbarContentStyle.js";


class SnackbarContent extends React.Component {
  
  constructor(props){
    super(props)
    this.state = {
      show : true,
    }
  }
  

  componentDidMount(){
    this.setState({show: true})
  }
  closeAlert = () =>{
    //console.log("close")
    this.setState({show: false});
    //console.log(this.state.show)
  };
  handleExited = () =>{
    this.props.onExited();
  }
  render(){
    const {classes} = this.props;
    const { message, color, close, icon } = this.props;
    let action = [];
    if (close !== undefined) {
      action = [
        <IconButton
          className={classes.iconButton}
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={this.closeAlert}
        >
          <Close className={classes.close} />
        </IconButton>
      ];
    }
    let snackIcon = null;
    //let iIcon = this.props.icon
    switch (typeof icon) {
      case "object":
        snackIcon = <this.props.icon className={classes.icon} />;
        break;
      case "string":
        snackIcon = <Icon className={classes.icon}>{this.props.icon}</Icon>;
        break;
      default:
        snackIcon = null;
        break;
    }
    
    return (
      <Grow in={this.state.show} mountOnEnter unmountOnExit onExited={this.handleExited}>
        <Snack
          message={
            <div>
              {snackIcon}
              {message}
              {close !== undefined ? action : null}
            </div>
          }
          classes={{
            root: classes.root + " " + classes[color],
            message: classes.message + " " + classes.container
          }}
        />
      </Grow>
    );
  }
}

SnackbarContent.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(SnackbarContent);